import { useState, useEffect, useRef } from 'react';
import { useForm } from "react-hook-form";

import InfoCard from '../widgets/InfoCard';
import { appConfig } from '../../services/config';

import '../Main.css';

function AuthMdInfo(props) {  

  /* Form Validation */
	
  const {
    register,
    formState: { errors },
    trigger
  } = useForm();

  /* Data */

  props.connectData.getData = getData;
  props.connectData.handleCloseInfo = handleCloseInfo;
  props.connectData.trigger = trigger;

  const handleDisplayCmdData = props.connectData.handleDisplayCmdData; 

  const defaultData = {
    titleLink: appConfig.iuaITI103Url,
     wellKnownUri: appConfig.wellKnownUri
  };   

  const wellKnownUriRef = useRef();

  function getData() {
    return  {
      wellKnownUri: wellKnownUriRef.current?.value     
    }
  }

  /* Info Card */

  const [infoCardIsOpen, setInfoCardIsOpen] = useState(false); 
  const [authServerMDCardIsOpen, setAuthServerMDCardIsOpen] = useState(false); 
  const [wellKnownUriCardIsOpen, setWellKnownUriCardIsOpen] = useState(false); 

  function handleCloseInfo() {
    setInfoCardIsOpen(false);
    setAuthServerMDCardIsOpen(false);
    setWellKnownUriCardIsOpen(false);
  }

  const [isInfoHover, setIsInfoHover] = useState(false);
  const [isAuthServerMDHover, setIsAuthServerMDHover] = useState(false);
  const [isWellKnownUriHover, setIsWellKnownUriHover] = useState(false);

  const isInfoHoverRef = useRef(isInfoHover);
  const isAuthServerMDHoverRef = useRef(isAuthServerMDHover);
  const isWellKnownUriHoverRef = useRef(isWellKnownUriHover);

  isInfoHoverRef.current = isInfoHover;
  isAuthServerMDHoverRef.current = isAuthServerMDHover;
  isWellKnownUriHoverRef.current = isWellKnownUriHover;

  useEffect(() => {
    isInfoHoverRef.current && setInfoCardIsOpen(true);
    const timer = setTimeout(() => {
      isAuthServerMDHoverRef.current && setAuthServerMDCardIsOpen(true);
      isWellKnownUriHoverRef.current && setWellKnownUriCardIsOpen(true);
    }, 800);
    return () => clearTimeout(timer);
  }, [isInfoHover, isAuthServerMDHover, isWellKnownUriHover]);

  return (
    <div className="row">
    <div className="col-8">
      
      <div className="row">
        <div className="spc-ml-15">
        <h5 className="main-title"><span 
            onMouseEnter={() => setIsAuthServerMDHover(true)}
            onMouseOut={() => {setIsAuthServerMDHover(false); handleCloseInfo()}} 
            > Authorization Server Metadata </span> 
              (<a className='aLink' href={defaultData.titleLink} target="_blank" rel="noreferrer">
                IUA ITI-103 Get Authorization Server Metadata</a>)</h5>
        </div>
      </div>

      {/* Well Known URI */}
      
      <div className="md-form spc-pb-10">
        <label htmlFor="wellKnownUri" className="active" 
          onMouseEnter={() => setIsWellKnownUriHover(true)}
          onMouseOut={() => {setIsWellKnownUriHover(false); handleCloseInfo()}}        
          > Well Known URI 
          <span className="required-text"> (required) </span></label>
        <input type="text" id="wellKnownUri" className="form-control" spellCheck="false"
          defaultValue={defaultData.wellKnownUri}          
          {...register("wellKnownUri", {        
            required: "Well Known URI is required",    
            pattern: {
              value: /^http(s)?:\/\/[a-zA-Z0-9_+-]+(:[0-9]+)?(\/)?[-a-zA-Z0-9()@:%_+.~#?&//=]+/i,
              message: "Well Known URL is invalid",
            },
            onBlur: () => trigger("wellKnownUri")
          })}
          ref={e => {
            const { ref } = register('wellKnownUri');
            ref(e);
            wellKnownUriRef.current = e;
          }}
          onChange={handleDisplayCmdData}
        />
        {errors.wellKnownUri && (
          <div className="validation-msg error">{errors.wellKnownUri.message}</div>
        )}
      </div>
      
    </div>
      
    <div className="col-4">
      <div className="algn-right"><i className="fa fa-info-circle sm" 
        onMouseEnter={() => setIsInfoHover(true)}
        onMouseOut={() => {setIsInfoHover(false); handleCloseInfo()}}        
        ></i></div>
      <div>
        {infoCardIsOpen && <InfoCard id="info"></InfoCard>}
        {authServerMDCardIsOpen && <InfoCard id="authServerMD"></InfoCard>}
        {wellKnownUriCardIsOpen && <InfoCard id="wellKnownUri"></InfoCard>}  
      </div>
    </div>
  </div>
  );
}

export default AuthMdInfo;
